export const NOT_FOUND_SEO_ATTR = 'data-ab-not-found-seo';
export const NOT_FOUND_TITLE = 'Page Not Found | Angler Built';
export const NOT_FOUND_DESCRIPTION =
  'The requested Angler Built page could not be found.';
export const NOT_FOUND_ROBOTS = 'noindex,follow';
